import { render, staticRenderFns } from "./SpreadsheetHeader.vue?vue&type=template&id=2a58ed7a&scoped=true&"
var script = {}
import style0 from "./SpreadsheetHeader.vue?vue&type=style&index=0&id=2a58ed7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a58ed7a",
  null
  
)

export default component.exports